module.exports = __webpack_public_path__ + "static/media/11.8a4c4cc0.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/moan/11.mp3
// module id = 487
// module chunks = 0